// Generated from arcade-recorder/docs/arcade-demo-tracker.csv by arcade-recorder/src/export-tutorials.mjs. Do not edit.
export interface Tutorial {
  id: number;
  title: string;
  group: string;
  category: string;
  audience: "agent" | "admin";
  tags: string[];
  nextId?: number;
  thumbnail: string;
  placements: string[];
  steps: number;
  seconds: number;
  chapters: { title: string; subtitle: string }[];
  flowId: string;
  shareUrl: string;
  embedUrl: string;
  editUrl: string;
  guide?: string;
}

export const TUTORIALS: readonly Tutorial[] = [
  {
    id: 1,
    title: "Invite a user to an organization",
    group: "Team access",
    category: "Access",
    audience: "admin",
    tags: ["MEMBER", "INVITE", "PERMISSION"],
    nextId: 2,
    thumbnail: "https://app.arcade.software/og/kmlsXZDgS7ZDSHP40BYb",
    placements: ["/settings/users"],
    steps: 23,
    seconds: 29,
    chapters: [
      {
        title: "Invite an organization user",
        subtitle: "Enter the new user's details and send an invitation.",
      },
      {
        title: "Manage the invitation",
        subtitle: "Resend and then revoke the pending invitation.",
      },
      {
        title: "Update organization permissions",
        subtitle: "Change Mariam's organization role to Org Admin and save it.",
      },
      {
        title: "Grant workspace access",
        subtitle:
          "Change back to Org Member and add Dubai Clinic with the Workspace Member role.",
      },
      {
        title: "Verify saved workspace access",
        subtitle:
          "Reopen Mariam's details and verify the saved organization role, workspace, and workspace role.",
      },
    ],
    flowId: "kmlsXZDgS7ZDSHP40BYb",
    shareUrl: "https://app.arcade.software/share/kmlsXZDgS7ZDSHP40BYb",
    embedUrl:
      "https://demo.arcade.software/kmlsXZDgS7ZDSHP40BYb?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/kmlsXZDgS7ZDSHP40BYb/edit",
    guide: "docs/help/organization-access.md#topic-1",
  },
  {
    id: 2,
    title: "Invite a user to a workspace",
    group: "Team access",
    category: "Access",
    audience: "admin",
    tags: ["MEMBER", "INVITE", "PERMISSION"],
    nextId: 60,
    thumbnail: "https://app.arcade.software/og/ixrYehJ1Gcq1Hsj7Z3Y5",
    placements: ["/settings/workspace-users"],
    steps: 15,
    seconds: 20,
    chapters: [
      {
        title: "Invite a workspace user",
        subtitle: "Add a user with the Workspace Agent role.",
      },
      {
        title: "Update workspace permissions",
        subtitle:
          "Change Omar's role and reopen the members list to verify it.",
      },
    ],
    flowId: "ixrYehJ1Gcq1Hsj7Z3Y5",
    shareUrl: "https://app.arcade.software/share/ixrYehJ1Gcq1Hsj7Z3Y5",
    embedUrl:
      "https://demo.arcade.software/ixrYehJ1Gcq1Hsj7Z3Y5?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/ixrYehJ1Gcq1Hsj7Z3Y5/edit",
    guide: "docs/help/workspace-access.md#topic-2",
  },
  {
    id: 3,
    title: "Update organization user permissions",
    group: "Team access",
    category: "Access",
    audience: "admin",
    tags: ["MEMBER", "INVITE", "PERMISSION"],
    nextId: 2,
    thumbnail: "https://app.arcade.software/og/kmlsXZDgS7ZDSHP40BYb",
    placements: ["/settings/users"],
    steps: 23,
    seconds: 29,
    chapters: [
      {
        title: "Invite an organization user",
        subtitle: "Enter the new user's details and send an invitation.",
      },
      {
        title: "Manage the invitation",
        subtitle: "Resend and then revoke the pending invitation.",
      },
      {
        title: "Update organization permissions",
        subtitle: "Change Mariam's organization role to Org Admin and save it.",
      },
      {
        title: "Grant workspace access",
        subtitle:
          "Change back to Org Member and add Dubai Clinic with the Workspace Member role.",
      },
      {
        title: "Verify saved workspace access",
        subtitle:
          "Reopen Mariam's details and verify the saved organization role, workspace, and workspace role.",
      },
    ],
    flowId: "kmlsXZDgS7ZDSHP40BYb",
    shareUrl: "https://app.arcade.software/share/kmlsXZDgS7ZDSHP40BYb",
    embedUrl:
      "https://demo.arcade.software/kmlsXZDgS7ZDSHP40BYb?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/kmlsXZDgS7ZDSHP40BYb/edit",
    guide: "docs/help/organization-access.md#topic-3",
  },
  {
    id: 4,
    title: "Update workspace user permissions",
    group: "Team access",
    category: "Access",
    audience: "admin",
    tags: ["MEMBER", "INVITE", "PERMISSION"],
    nextId: 60,
    thumbnail: "https://app.arcade.software/og/ixrYehJ1Gcq1Hsj7Z3Y5",
    placements: ["/settings/workspace-users"],
    steps: 15,
    seconds: 20,
    chapters: [
      {
        title: "Invite a workspace user",
        subtitle: "Add a user with the Workspace Agent role.",
      },
      {
        title: "Update workspace permissions",
        subtitle:
          "Change Omar's role and reopen the members list to verify it.",
      },
    ],
    flowId: "ixrYehJ1Gcq1Hsj7Z3Y5",
    shareUrl: "https://app.arcade.software/share/ixrYehJ1Gcq1Hsj7Z3Y5",
    embedUrl:
      "https://demo.arcade.software/ixrYehJ1Gcq1Hsj7Z3Y5?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/ixrYehJ1Gcq1Hsj7Z3Y5/edit",
    guide: "docs/help/workspace-access.md#topic-4",
  },
  {
    id: 20,
    title: "View all contacts",
    group: "Contacts",
    category: "Browse and profiles",
    audience: "agent",
    tags: ["CONTACT", "VIEW", "SORT"],
    nextId: 21,
    thumbnail: "https://app.arcade.software/og/vlVjkgqUD7ZvWWReRoxF",
    placements: ["/contacts"],
    steps: 9,
    seconds: 15,
    chapters: [
      {
        title: "Customize contact columns",
        subtitle: "Open All Contacts and enable the Channels column.",
      },
      {
        title: "Sort contacts in card view",
        subtitle: "Switch to cards and sort contacts by Date Added.",
      },
      {
        title: "Search contacts",
        subtitle: "Return to list view and search for Emma Johnson.",
      },
    ],
    flowId: "vlVjkgqUD7ZvWWReRoxF",
    shareUrl: "https://app.arcade.software/share/vlVjkgqUD7ZvWWReRoxF",
    embedUrl:
      "https://demo.arcade.software/vlVjkgqUD7ZvWWReRoxF?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/vlVjkgqUD7ZvWWReRoxF/edit",
    guide: "docs/help/contacts.md#topic-20",
  },
  {
    id: 21,
    title: "View and update a single contact",
    group: "Contacts",
    category: "Browse and profiles",
    audience: "agent",
    tags: ["CONTACT", "LIFECYCLE", "TAG"],
    nextId: 22,
    thumbnail: "https://app.arcade.software/og/ImBmQC4zxwPTYw0NbSzt",
    placements: ["/contacts"],
    steps: 18,
    seconds: 29,
    chapters: [
      {
        title: "Create a contact",
        subtitle: "Add Yasmin Nasser with contact details, lifecycle, and tag.",
      },
      {
        title: "Edit the contact",
        subtitle:
          "Find Yasmin, update her address and insurer, and verify the saved details.",
      },
    ],
    flowId: "ImBmQC4zxwPTYw0NbSzt",
    shareUrl: "https://app.arcade.software/share/ImBmQC4zxwPTYw0NbSzt",
    embedUrl:
      "https://demo.arcade.software/ImBmQC4zxwPTYw0NbSzt?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/ImBmQC4zxwPTYw0NbSzt/edit",
    guide: "docs/help/contacts.md#topic-21",
  },
  {
    id: 22,
    title: "View a contact full profile",
    group: "Contacts",
    category: "Browse and profiles",
    audience: "agent",
    tags: ["CONTACT", "VIEW"],
    nextId: 23,
    thumbnail: "https://app.arcade.software/og/dtxqyPdbOQpp2JQPdcGU",
    placements: ["/contacts"],
    steps: 10,
    seconds: 16,
    chapters: [
      {
        title: "View a contact profile",
        subtitle:
          "Open Emma Johnson's full profile and review its information tabs.",
      },
    ],
    flowId: "dtxqyPdbOQpp2JQPdcGU",
    shareUrl: "https://app.arcade.software/share/dtxqyPdbOQpp2JQPdcGU",
    embedUrl:
      "https://demo.arcade.software/dtxqyPdbOQpp2JQPdcGU?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/dtxqyPdbOQpp2JQPdcGU/edit",
    guide: "docs/help/contacts.md#topic-22",
  },
  {
    id: 23,
    title: "Filter contacts with date/time and useful combinations",
    group: "Contacts",
    category: "Filters, segments and export",
    audience: "agent",
    tags: ["CONTACT", "FILTER", "TAG"],
    nextId: 24,
    thumbnail: "https://app.arcade.software/og/fyn1mHbviQW3EjkHQwKt",
    placements: ["/contacts"],
    steps: 31,
    seconds: 35,
    chapters: [
      {
        title: "Apply quick date filters",
        subtitle:
          "Filter contacts by a creation date range and clear the filter.",
      },
      {
        title: "Add an advanced date filter",
        subtitle: "Set a Created At date range with an exact end time.",
      },
      {
        title: "Combine date and tag filters",
        subtitle: "Add the Follow-up Needed tag and compare AND with OR.",
      },
    ],
    flowId: "fyn1mHbviQW3EjkHQwKt",
    shareUrl: "https://app.arcade.software/share/fyn1mHbviQW3EjkHQwKt",
    embedUrl:
      "https://demo.arcade.software/fyn1mHbviQW3EjkHQwKt?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/fyn1mHbviQW3EjkHQwKt/edit",
    guide: "docs/help/contact-filters.md#topic-23",
  },
  {
    id: 24,
    title: "Save filtered contacts as a segment",
    group: "Contacts",
    category: "Filters, segments and export",
    audience: "agent",
    tags: ["SEGMENT", "FILTER", "TAG"],
    nextId: 25,
    thumbnail: "https://app.arcade.software/og/0n6bPncSXVre8BKxgsPO",
    placements: ["/contacts"],
    steps: 40,
    seconds: 47,
    chapters: [
      {
        title: "Create a contact segment",
        subtitle:
          "Combine a date range and follow-up tag, then save the segment.",
      },
      {
        title: "Edit the segment",
        subtitle: "Reopen the saved segment and change its tag filter.",
      },
      {
        title: "Verify and restore the segment",
        subtitle:
          "Check the saved edit, restore the follow-up tag, and reopen the rules.",
      },
    ],
    flowId: "0n6bPncSXVre8BKxgsPO",
    shareUrl: "https://app.arcade.software/share/0n6bPncSXVre8BKxgsPO",
    embedUrl:
      "https://demo.arcade.software/0n6bPncSXVre8BKxgsPO?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/0n6bPncSXVre8BKxgsPO/edit",
    guide: "docs/help/segments.md#topic-24",
  },
  {
    id: 25,
    title: "Export a segment",
    group: "Contacts",
    category: "Filters, segments and export",
    audience: "agent",
    tags: ["SEGMENT", "EXPORT"],
    thumbnail: "https://app.arcade.software/og/a7I2SVSYm91F3S1y9TTh",
    placements: ["/contacts"],
    steps: 10,
    seconds: 15,
    chapters: [
      {
        title: "Export a segment",
        subtitle:
          "Export the Needs Follow-up segment as a CSV and download it.",
      },
      {
        title: "View export history",
        subtitle: "Reopen Export History from the More menu.",
      },
    ],
    flowId: "a7I2SVSYm91F3S1y9TTh",
    shareUrl: "https://app.arcade.software/share/a7I2SVSYm91F3S1y9TTh",
    embedUrl:
      "https://demo.arcade.software/a7I2SVSYm91F3S1y9TTh?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/a7I2SVSYm91F3S1y9TTh/edit",
    guide: "docs/help/segments.md#topic-25",
  },
  {
    id: 29,
    title: "View all conversations",
    group: "Inbox and messaging",
    category: "Inbox views",
    audience: "agent",
    tags: ["VIEW", "FOLLOW_UP", "MENTION"],
    nextId: 35,
    thumbnail: "https://app.arcade.software/og/x2sWAv9XmvojfxQMgehF",
    placements: ["/inbox/:id"],
    steps: 22,
    seconds: 30,
    chapters: [
      {
        title: "View all conversations",
        subtitle: "Show all statuses and open a conversation from All.",
      },
      {
        title: "View unassigned conversations",
        subtitle: "Open Unassigned and inspect a conversation.",
      },
      {
        title: "View mentions",
        subtitle: "Open Mentions and inspect a conversation that mentions you.",
      },
      {
        title: "View participating conversations",
        subtitle: "Open Participating and inspect a conversation.",
      },
      {
        title: "Compare unreplied conversations",
        subtitle: "Open a result in Mine, then compare All and Unassigned.",
      },
      {
        title: "Compare follow-up conversations",
        subtitle:
          "Open a result in Mine, then compare All, Teammates, and Unassigned.",
      },
    ],
    flowId: "x2sWAv9XmvojfxQMgehF",
    shareUrl: "https://app.arcade.software/share/x2sWAv9XmvojfxQMgehF",
    embedUrl:
      "https://demo.arcade.software/x2sWAv9XmvojfxQMgehF?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/x2sWAv9XmvojfxQMgehF/edit",
    guide: "docs/help/inbox-views.md#topic-29",
  },
  {
    id: 30,
    title: "View unassigned conversations",
    group: "Inbox and messaging",
    category: "Inbox views",
    audience: "agent",
    tags: ["VIEW", "FOLLOW_UP", "MENTION"],
    nextId: 35,
    thumbnail: "https://app.arcade.software/og/x2sWAv9XmvojfxQMgehF",
    placements: ["/inbox/:id"],
    steps: 22,
    seconds: 30,
    chapters: [
      {
        title: "View all conversations",
        subtitle: "Show all statuses and open a conversation from All.",
      },
      {
        title: "View unassigned conversations",
        subtitle: "Open Unassigned and inspect a conversation.",
      },
      {
        title: "View mentions",
        subtitle: "Open Mentions and inspect a conversation that mentions you.",
      },
      {
        title: "View participating conversations",
        subtitle: "Open Participating and inspect a conversation.",
      },
      {
        title: "Compare unreplied conversations",
        subtitle: "Open a result in Mine, then compare All and Unassigned.",
      },
      {
        title: "Compare follow-up conversations",
        subtitle:
          "Open a result in Mine, then compare All, Teammates, and Unassigned.",
      },
    ],
    flowId: "x2sWAv9XmvojfxQMgehF",
    shareUrl: "https://app.arcade.software/share/x2sWAv9XmvojfxQMgehF",
    embedUrl:
      "https://demo.arcade.software/x2sWAv9XmvojfxQMgehF?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/x2sWAv9XmvojfxQMgehF/edit",
    guide: "docs/help/inbox-views.md#topic-30",
  },
  {
    id: 31,
    title: "View conversations requiring follow-ups",
    group: "Inbox and messaging",
    category: "Inbox views",
    audience: "agent",
    tags: ["VIEW", "FOLLOW_UP", "MENTION"],
    nextId: 35,
    thumbnail: "https://app.arcade.software/og/x2sWAv9XmvojfxQMgehF",
    placements: ["/inbox/:id"],
    steps: 22,
    seconds: 30,
    chapters: [
      {
        title: "View all conversations",
        subtitle: "Show all statuses and open a conversation from All.",
      },
      {
        title: "View unassigned conversations",
        subtitle: "Open Unassigned and inspect a conversation.",
      },
      {
        title: "View mentions",
        subtitle: "Open Mentions and inspect a conversation that mentions you.",
      },
      {
        title: "View participating conversations",
        subtitle: "Open Participating and inspect a conversation.",
      },
      {
        title: "Compare unreplied conversations",
        subtitle: "Open a result in Mine, then compare All and Unassigned.",
      },
      {
        title: "Compare follow-up conversations",
        subtitle:
          "Open a result in Mine, then compare All, Teammates, and Unassigned.",
      },
    ],
    flowId: "x2sWAv9XmvojfxQMgehF",
    shareUrl: "https://app.arcade.software/share/x2sWAv9XmvojfxQMgehF",
    embedUrl:
      "https://demo.arcade.software/x2sWAv9XmvojfxQMgehF?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/x2sWAv9XmvojfxQMgehF/edit",
    guide: "docs/help/inbox-views.md#topic-31",
  },
  {
    id: 32,
    title: "View conversations mentioning me",
    group: "Inbox and messaging",
    category: "Inbox views",
    audience: "agent",
    tags: ["VIEW", "FOLLOW_UP", "MENTION"],
    nextId: 35,
    thumbnail: "https://app.arcade.software/og/x2sWAv9XmvojfxQMgehF",
    placements: ["/inbox/:id"],
    steps: 22,
    seconds: 30,
    chapters: [
      {
        title: "View all conversations",
        subtitle: "Show all statuses and open a conversation from All.",
      },
      {
        title: "View unassigned conversations",
        subtitle: "Open Unassigned and inspect a conversation.",
      },
      {
        title: "View mentions",
        subtitle: "Open Mentions and inspect a conversation that mentions you.",
      },
      {
        title: "View participating conversations",
        subtitle: "Open Participating and inspect a conversation.",
      },
      {
        title: "Compare unreplied conversations",
        subtitle: "Open a result in Mine, then compare All and Unassigned.",
      },
      {
        title: "Compare follow-up conversations",
        subtitle:
          "Open a result in Mine, then compare All, Teammates, and Unassigned.",
      },
    ],
    flowId: "x2sWAv9XmvojfxQMgehF",
    shareUrl: "https://app.arcade.software/share/x2sWAv9XmvojfxQMgehF",
    embedUrl:
      "https://demo.arcade.software/x2sWAv9XmvojfxQMgehF?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/x2sWAv9XmvojfxQMgehF/edit",
    guide: "docs/help/inbox-views.md#topic-32",
  },
  {
    id: 33,
    title: "View conversations I participated in",
    group: "Inbox and messaging",
    category: "Inbox views",
    audience: "agent",
    tags: ["VIEW", "FOLLOW_UP", "MENTION"],
    nextId: 35,
    thumbnail: "https://app.arcade.software/og/x2sWAv9XmvojfxQMgehF",
    placements: ["/inbox/:id"],
    steps: 22,
    seconds: 30,
    chapters: [
      {
        title: "View all conversations",
        subtitle: "Show all statuses and open a conversation from All.",
      },
      {
        title: "View unassigned conversations",
        subtitle: "Open Unassigned and inspect a conversation.",
      },
      {
        title: "View mentions",
        subtitle: "Open Mentions and inspect a conversation that mentions you.",
      },
      {
        title: "View participating conversations",
        subtitle: "Open Participating and inspect a conversation.",
      },
      {
        title: "Compare unreplied conversations",
        subtitle: "Open a result in Mine, then compare All and Unassigned.",
      },
      {
        title: "Compare follow-up conversations",
        subtitle:
          "Open a result in Mine, then compare All, Teammates, and Unassigned.",
      },
    ],
    flowId: "x2sWAv9XmvojfxQMgehF",
    shareUrl: "https://app.arcade.software/share/x2sWAv9XmvojfxQMgehF",
    embedUrl:
      "https://demo.arcade.software/x2sWAv9XmvojfxQMgehF?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/x2sWAv9XmvojfxQMgehF/edit",
    guide: "docs/help/inbox-views.md#topic-33",
  },
  {
    id: 34,
    title: "View unattended conversations",
    group: "Inbox and messaging",
    category: "Inbox views",
    audience: "agent",
    tags: ["VIEW", "FOLLOW_UP", "MENTION"],
    nextId: 35,
    thumbnail: "https://app.arcade.software/og/x2sWAv9XmvojfxQMgehF",
    placements: ["/inbox/:id"],
    steps: 22,
    seconds: 30,
    chapters: [
      {
        title: "View all conversations",
        subtitle: "Show all statuses and open a conversation from All.",
      },
      {
        title: "View unassigned conversations",
        subtitle: "Open Unassigned and inspect a conversation.",
      },
      {
        title: "View mentions",
        subtitle: "Open Mentions and inspect a conversation that mentions you.",
      },
      {
        title: "View participating conversations",
        subtitle: "Open Participating and inspect a conversation.",
      },
      {
        title: "Compare unreplied conversations",
        subtitle: "Open a result in Mine, then compare All and Unassigned.",
      },
      {
        title: "Compare follow-up conversations",
        subtitle:
          "Open a result in Mine, then compare All, Teammates, and Unassigned.",
      },
    ],
    flowId: "x2sWAv9XmvojfxQMgehF",
    shareUrl: "https://app.arcade.software/share/x2sWAv9XmvojfxQMgehF",
    embedUrl:
      "https://demo.arcade.software/x2sWAv9XmvojfxQMgehF?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/x2sWAv9XmvojfxQMgehF/edit",
    guide: "docs/help/inbox-views.md#topic-34",
  },
  {
    id: 35,
    title: "Quickly filter conversations by channels, tags or lifecycle",
    group: "Inbox and messaging",
    category: "Inbox views",
    audience: "agent",
    tags: ["FILTER", "TAG", "LIFECYCLE"],
    nextId: 36,
    thumbnail: "https://app.arcade.software/og/KhBKSiYnG0J9fQLPbXbi",
    placements: ["/inbox/:id"],
    steps: 17,
    seconds: 23,
    chapters: [
      {
        title: "Filter conversations by tag",
        subtitle: "Apply the VIP Patient tag filter.",
      },
      {
        title: "Add a channel filter",
        subtitle:
          "Add the Instagram channel filter and then clear the filters.",
      },
      {
        title: "Add an advanced lifecycle filter",
        subtitle:
          "Open Advanced filters and add a Lifecycle rule for New Lead.",
      },
    ],
    flowId: "KhBKSiYnG0J9fQLPbXbi",
    shareUrl: "https://app.arcade.software/share/KhBKSiYnG0J9fQLPbXbi",
    embedUrl:
      "https://demo.arcade.software/KhBKSiYnG0J9fQLPbXbi?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/KhBKSiYnG0J9fQLPbXbi/edit",
    guide: "docs/help/inbox-filters.md#topic-35",
  },
  {
    id: 36,
    title: "Switch inbox views between Open, Closed, Snoozed and All",
    group: "Inbox and messaging",
    category: "Inbox views",
    audience: "agent",
    tags: ["VIEW", "SNOOZE"],
    nextId: 37,
    thumbnail: "https://app.arcade.software/og/QgfxNysL1bgan6MI4vqH",
    placements: ["/inbox/:id"],
    steps: 10,
    seconds: 13,
    chapters: [
      {
        title: "Switch conversation status views",
        subtitle: "Compare Open, Closed, Snoozed, and All conversations.",
      },
    ],
    flowId: "QgfxNysL1bgan6MI4vqH",
    shareUrl: "https://app.arcade.software/share/QgfxNysL1bgan6MI4vqH",
    embedUrl:
      "https://demo.arcade.software/QgfxNysL1bgan6MI4vqH?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/QgfxNysL1bgan6MI4vqH/edit",
    guide: "docs/help/inbox-filters.md#topic-36",
  },
  {
    id: 37,
    title: "Sort inbox conversations by activity, follow-up and waiting time",
    group: "Inbox and messaging",
    category: "Inbox views",
    audience: "agent",
    tags: ["SORT", "FOLLOW_UP"],
    nextId: 38,
    thumbnail: "https://app.arcade.software/og/sa4qSllH8DOlPzMiH1no",
    placements: ["/inbox/:id"],
    steps: 8,
    seconds: 12,
    chapters: [
      {
        title: "Sort conversations",
        subtitle:
          "Compare sorting by oldest activity, due soonest, and oldest waiting time.",
      },
    ],
    flowId: "sa4qSllH8DOlPzMiH1no",
    shareUrl: "https://app.arcade.software/share/sa4qSllH8DOlPzMiH1no",
    embedUrl:
      "https://demo.arcade.software/sa4qSllH8DOlPzMiH1no?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/sa4qSllH8DOlPzMiH1no/edit",
    guide: "docs/help/inbox-filters.md#topic-37",
  },
  {
    id: 38,
    title: "Apply complex conversation filters",
    group: "Inbox and messaging",
    category: "Inbox views",
    audience: "agent",
    tags: ["FILTER", "LIFECYCLE", "FOLLOW_UP"],
    nextId: 39,
    thumbnail: "https://app.arcade.software/og/pyjdknVLmLcGkLzc8BPu",
    placements: ["/inbox/:id"],
    steps: 32,
    seconds: 37,
    chapters: [
      {
        title: "Create a filtered inbox view",
        subtitle:
          "Combine lifecycle and follow-up rules, compare AND and OR, and save a private view.",
      },
      {
        title: "Edit and share the view",
        subtitle: "Rename the saved view and make it available to everyone.",
      },
      {
        title: "Delete the view",
        subtitle: "Delete the shared view after verifying its saved settings.",
      },
    ],
    flowId: "pyjdknVLmLcGkLzc8BPu",
    shareUrl: "https://app.arcade.software/share/pyjdknVLmLcGkLzc8BPu",
    embedUrl:
      "https://demo.arcade.software/pyjdknVLmLcGkLzc8BPu?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/pyjdknVLmLcGkLzc8BPu/edit",
    guide: "docs/help/inbox-filters.md#topic-38",
  },
  {
    id: 39,
    title: "Change a conversation lifecycle and verify the new stage",
    group: "Inbox and messaging",
    category: "Conversation actions",
    audience: "agent",
    tags: ["LIFECYCLE"],
    nextId: 40,
    thumbnail: "https://app.arcade.software/og/m5laJBopYo4BvIFtF4Y3",
    placements: ["/inbox/:id"],
    steps: 7,
    seconds: 13,
    chapters: [
      {
        title: "Change the lifecycle",
        subtitle:
          "Set Emma's lifecycle to Contacted and verify it in the contact drawer.",
      },
    ],
    flowId: "m5laJBopYo4BvIFtF4Y3",
    shareUrl: "https://app.arcade.software/share/m5laJBopYo4BvIFtF4Y3",
    embedUrl:
      "https://demo.arcade.software/m5laJBopYo4BvIFtF4Y3?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/m5laJBopYo4BvIFtF4Y3/edit",
    guide: "docs/help/conversation-details.md#topic-39",
  },
  {
    id: 40,
    title: "Update a conversation assigned agent",
    group: "Inbox and messaging",
    category: "Conversation actions",
    audience: "agent",
    tags: ["ASSIGNMENT", "NOTE"],
    nextId: 41,
    thumbnail: "https://app.arcade.software/og/0lqI3W6XAonrM5rrQAQM",
    placements: ["/inbox/:id"],
    steps: 8,
    seconds: 15,
    chapters: [
      {
        title: "Assign an agent",
        subtitle: "Transfer Emma's conversation to Mariam with a reason.",
      },
    ],
    flowId: "0lqI3W6XAonrM5rrQAQM",
    shareUrl: "https://app.arcade.software/share/0lqI3W6XAonrM5rrQAQM",
    embedUrl:
      "https://demo.arcade.software/0lqI3W6XAonrM5rrQAQM?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/0lqI3W6XAonrM5rrQAQM/edit",
    guide: "docs/help/conversation-details.md#topic-40",
  },
  {
    id: 41,
    title: "Update a conversation assigned team",
    group: "Inbox and messaging",
    category: "Conversation actions",
    audience: "agent",
    tags: ["ASSIGNMENT", "TEAM", "NOTE"],
    nextId: 42,
    thumbnail: "https://app.arcade.software/og/nPTb84cTiBzIOZgpnNFy",
    placements: ["/inbox/:id"],
    steps: 8,
    seconds: 15,
    chapters: [
      {
        title: "Assign a team",
        subtitle: "Assign Emma's conversation to Front Desk with a reason.",
      },
    ],
    flowId: "nPTb84cTiBzIOZgpnNFy",
    shareUrl: "https://app.arcade.software/share/nPTb84cTiBzIOZgpnNFy",
    embedUrl:
      "https://demo.arcade.software/nPTb84cTiBzIOZgpnNFy?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/nPTb84cTiBzIOZgpnNFy/edit",
    guide: "docs/help/conversation-details.md#topic-41",
  },
  {
    id: 42,
    title: "Update conversation tags",
    group: "Inbox and messaging",
    category: "Conversation actions",
    audience: "agent",
    tags: ["TAG"],
    nextId: 43,
    thumbnail: "https://app.arcade.software/og/yMVd1XKyWln1AaP9zFOh",
    placements: ["/inbox/:id"],
    steps: 7,
    seconds: 14,
    chapters: [
      {
        title: "Add conversation tags",
        subtitle: "Add Follow-up Needed and New Patient to the conversation.",
      },
      {
        title: "Remove a tag",
        subtitle: "Remove New Patient while keeping Follow-up Needed.",
      },
    ],
    flowId: "yMVd1XKyWln1AaP9zFOh",
    shareUrl: "https://app.arcade.software/share/yMVd1XKyWln1AaP9zFOh",
    embedUrl:
      "https://demo.arcade.software/yMVd1XKyWln1AaP9zFOh?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/yMVd1XKyWln1AaP9zFOh/edit",
    guide: "docs/help/conversation-details.md#topic-42",
  },
  {
    id: 43,
    title: "Update interests in a conversation",
    group: "Inbox and messaging",
    category: "Conversation actions",
    audience: "agent",
    tags: ["INTEREST"],
    nextId: 44,
    thumbnail: "https://app.arcade.software/og/HzJqw1AcJ5zTt5rcqgVR",
    placements: ["/inbox/:id"],
    steps: 5,
    seconds: 11,
    chapters: [
      {
        title: "Add a treatment interest",
        subtitle:
          "Add Laser Hair Removal (Half Legs) to the contact's interests.",
      },
      {
        title: "Remove the treatment interest",
        subtitle: "Remove the treatment from the contact panel.",
      },
    ],
    flowId: "HzJqw1AcJ5zTt5rcqgVR",
    shareUrl: "https://app.arcade.software/share/HzJqw1AcJ5zTt5rcqgVR",
    embedUrl:
      "https://demo.arcade.software/HzJqw1AcJ5zTt5rcqgVR?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/HzJqw1AcJ5zTt5rcqgVR/edit",
    guide: "docs/help/conversation-details.md#topic-43",
  },
  {
    id: 44,
    title: "Edit contact details from a conversation",
    group: "Inbox and messaging",
    category: "Conversation actions",
    audience: "agent",
    tags: ["CONTACT"],
    nextId: 101,
    thumbnail: "https://app.arcade.software/og/B745EPxd09eF398YObHU",
    placements: ["/inbox/:id"],
    steps: 8,
    seconds: 18,
    chapters: [
      {
        title: "Edit contact details",
        subtitle:
          "Update Emma's email and address, save, and reopen the drawer to verify them.",
      },
    ],
    flowId: "B745EPxd09eF398YObHU",
    shareUrl: "https://app.arcade.software/share/B745EPxd09eF398YObHU",
    embedUrl:
      "https://demo.arcade.software/B745EPxd09eF398YObHU?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/B745EPxd09eF398YObHU/edit",
    guide: "docs/help/conversation-details.md#topic-44",
  },
  {
    id: 45,
    title: "Send a message in a conversation",
    group: "Inbox and messaging",
    category: "Messaging",
    audience: "agent",
    tags: ["MESSAGE"],
    nextId: 48,
    thumbnail: "https://app.arcade.software/og/5TvfrAMuUxekwjcKelEY",
    placements: ["/inbox"],
    steps: 5,
    seconds: 11,
    chapters: [
      {
        title: "Send a message",
        subtitle:
          "Open Emma Johnson's conversation, enter a reply, and send it.",
      },
    ],
    flowId: "5TvfrAMuUxekwjcKelEY",
    shareUrl: "https://app.arcade.software/share/5TvfrAMuUxekwjcKelEY",
    embedUrl:
      "https://demo.arcade.software/5TvfrAMuUxekwjcKelEY?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/5TvfrAMuUxekwjcKelEY/edit",
    guide: "docs/help/replying.md#topic-45",
  },
  {
    id: 48,
    title: "Send saved files and quick replies",
    group: "Inbox and messaging",
    category: "Messaging",
    audience: "agent",
    tags: ["MESSAGE", "SNIPPET", "SAVED_FILE"],
    nextId: 50,
    thumbnail: "https://app.arcade.software/og/aPDiFZ8qmkTQylluoow0",
    placements: ["/inbox"],
    steps: 14,
    seconds: 19,
    chapters: [
      {
        title: "Send a snippet",
        subtitle: "Find the Thank You snippet and send it in the conversation.",
      },
      {
        title: "Send a saved file",
        subtitle:
          "Attach the saved first-visit PDF, add a caption, and send it.",
      },
    ],
    flowId: "aPDiFZ8qmkTQylluoow0",
    shareUrl: "https://app.arcade.software/share/aPDiFZ8qmkTQylluoow0",
    embedUrl:
      "https://demo.arcade.software/aPDiFZ8qmkTQylluoow0?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/aPDiFZ8qmkTQylluoow0/edit",
    guide: "docs/help/replying.md#topic-48",
  },
  {
    id: 50,
    title: "Log a call in a conversation",
    group: "Inbox and messaging",
    category: "Messaging",
    audience: "agent",
    tags: ["CALL", "NOTE"],
    nextId: 51,
    thumbnail: "https://app.arcade.software/og/O1tSfCChAukJAlfOEJXz",
    placements: ["/inbox"],
    steps: 8,
    seconds: 14,
    chapters: [
      {
        title: "Log a call",
        subtitle:
          "Record an answered outgoing call with its duration and notes.",
      },
    ],
    flowId: "O1tSfCChAukJAlfOEJXz",
    shareUrl: "https://app.arcade.software/share/O1tSfCChAukJAlfOEJXz",
    embedUrl:
      "https://demo.arcade.software/O1tSfCChAukJAlfOEJXz?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/O1tSfCChAukJAlfOEJXz/edit",
    guide: "docs/help/internal-notes.md#topic-50",
  },
  {
    id: 51,
    title: "Add a private note",
    group: "Inbox and messaging",
    category: "Messaging",
    audience: "agent",
    tags: ["NOTE"],
    nextId: 69,
    thumbnail: "https://app.arcade.software/og/WXCsh8U3hms0Q0sl5QFZ",
    placements: ["/inbox"],
    steps: 5,
    seconds: 11,
    chapters: [
      {
        title: "Add a private note",
        subtitle: "Write an internal note in Emma Johnson's conversation.",
      },
    ],
    flowId: "WXCsh8U3hms0Q0sl5QFZ",
    shareUrl: "https://app.arcade.software/share/WXCsh8U3hms0Q0sl5QFZ",
    embedUrl:
      "https://demo.arcade.software/WXCsh8U3hms0Q0sl5QFZ?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/WXCsh8U3hms0Q0sl5QFZ/edit",
    guide: "docs/help/internal-notes.md#topic-51",
  },
  {
    id: 58,
    title: "Configure response SLAs and reminders",
    group: "Workspace settings",
    category: "Inbox rules",
    audience: "admin",
    tags: ["SLA"],
    nextId: 59,
    thumbnail: "https://app.arcade.software/og/nLxiHn8Kz0UpyTGoYhDB",
    placements: ["/settings/sla"],
    steps: 21,
    seconds: 27,
    chapters: [
      {
        title: "Configure first reply reminders",
        subtitle:
          "Set the first reply target, reminder percentage, and recipients.",
      },
      {
        title: "Configure subsequent replies",
        subtitle: "Enable the subsequent reply clock and set its target.",
      },
      {
        title: "Copy notification settings",
        subtitle:
          "Copy first reply notifications to the subsequent reply clock.",
      },
      {
        title: "Save and verify SLAs",
        subtitle: "Review the settings, save changes, and reopen the SLA page.",
      },
    ],
    flowId: "nLxiHn8Kz0UpyTGoYhDB",
    shareUrl: "https://app.arcade.software/share/nLxiHn8Kz0UpyTGoYhDB",
    embedUrl:
      "https://demo.arcade.software/nLxiHn8Kz0UpyTGoYhDB?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/nLxiHn8Kz0UpyTGoYhDB/edit",
    guide: "docs/help/slas.md#topic-58",
  },
  {
    id: 59,
    title: "Configure team requirements and reassignment on reply",
    group: "Workspace settings",
    category: "Inbox rules",
    audience: "admin",
    tags: ["ASSIGNMENT", "TEAM"],
    nextId: 62,
    thumbnail: "https://app.arcade.software/og/bOmchCZqLblI8xhRmeB2",
    placements: ["/settings/assignment"],
    steps: 6,
    seconds: 12,
    chapters: [
      {
        title: "Configure assignment rules",
        subtitle:
          "Require a team, preserve the current assignee, and verify the saved settings.",
      },
    ],
    flowId: "bOmchCZqLblI8xhRmeB2",
    shareUrl: "https://app.arcade.software/share/bOmchCZqLblI8xhRmeB2",
    embedUrl:
      "https://demo.arcade.software/bOmchCZqLblI8xhRmeB2?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/bOmchCZqLblI8xhRmeB2/edit",
    guide: "docs/help/assignment.md#topic-59",
  },
  {
    id: 60,
    title: "Create and manage teams and their members",
    group: "Team access",
    category: "Teams",
    audience: "admin",
    tags: ["TEAM", "MEMBER", "ASSIGNMENT"],
    thumbnail: "https://app.arcade.software/og/Y9m6lKg3ZUI2V7zMVVcE",
    placements: ["/settings/teams"],
    steps: 25,
    seconds: 31,
    chapters: [
      {
        title: "Create a team",
        subtitle:
          "Choose a name, color, assignment strategy, and team members.",
      },
      {
        title: "Edit the team",
        subtitle: "Update the team settings and verify its saved membership.",
      },
      {
        title: "Delete the team",
        subtitle: "Delete the team and confirm the removal.",
      },
    ],
    flowId: "Y9m6lKg3ZUI2V7zMVVcE",
    shareUrl: "https://app.arcade.software/share/Y9m6lKg3ZUI2V7zMVVcE",
    embedUrl:
      "https://demo.arcade.software/Y9m6lKg3ZUI2V7zMVVcE?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/Y9m6lKg3ZUI2V7zMVVcE/edit",
    guide: "docs/help/teams.md#topic-60",
  },
  {
    id: 62,
    title: "Create, update and delete referral websites",
    group: "Workspace settings",
    category: "Integrations",
    audience: "admin",
    tags: ["WEBSITE"],
    nextId: 63,
    thumbnail: "https://app.arcade.software/og/cT8swKZ5BGLKwVuX63XH",
    placements: ["/settings/websites"],
    steps: 12,
    seconds: 19,
    chapters: [
      {
        title: "Create a referral website",
        subtitle: "Add a referral website with its domain and name.",
      },
      {
        title: "Edit the referral website",
        subtitle: "Update the website domain and display name.",
      },
      {
        title: "Delete the referral website",
        subtitle: "Delete the website and confirm its removal.",
      },
    ],
    flowId: "cT8swKZ5BGLKwVuX63XH",
    shareUrl: "https://app.arcade.software/share/cT8swKZ5BGLKwVuX63XH",
    embedUrl:
      "https://demo.arcade.software/cT8swKZ5BGLKwVuX63XH?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/cT8swKZ5BGLKwVuX63XH/edit",
    guide: "docs/help/websites.md#topic-62",
  },
  {
    id: 63,
    title: "Create, copy, rename and revoke API keys",
    group: "Workspace settings",
    category: "Integrations",
    audience: "admin",
    tags: ["API_KEY"],
    nextId: 64,
    thumbnail: "https://app.arcade.software/og/YXGX9n5q5Nr9j7pFJ0fh",
    placements: ["/settings/developer"],
    steps: 13,
    seconds: 20,
    chapters: [
      {
        title: "Create an API key",
        subtitle: "Create a named API key for reporting.",
      },
      {
        title: "Copy the API key",
        subtitle: "Copy the key from its one-time display.",
      },
      { title: "Rename the API key", subtitle: "Update the API key name." },
      {
        title: "Revoke the API key",
        subtitle: "Confirm the key name and delete it.",
      },
    ],
    flowId: "YXGX9n5q5Nr9j7pFJ0fh",
    shareUrl: "https://app.arcade.software/share/YXGX9n5q5Nr9j7pFJ0fh",
    embedUrl:
      "https://demo.arcade.software/YXGX9n5q5Nr9j7pFJ0fh?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/YXGX9n5q5Nr9j7pFJ0fh/edit",
    guide: "docs/help/api-keys.md#topic-63",
  },
  {
    id: 64,
    title: "Rename a workspace and find its ID",
    group: "Workspace settings",
    category: "Workspace and organization",
    audience: "admin",
    tags: ["WORKSPACE"],
    nextId: 65,
    thumbnail: "https://app.arcade.software/og/BbGJpZwajZCaQrgoJ8Ro",
    placements: ["/settings/workspace"],
    steps: 17,
    seconds: 24,
    chapters: [
      {
        title: "Create a workspace",
        subtitle: "Create a workspace from the account menu.",
      },
      {
        title: "Rename the workspace",
        subtitle: "Update the workspace name in Workspace General.",
      },
      {
        title: "Switch workspaces",
        subtitle:
          "Switch to Dubai Clinic and back to verify the renamed workspace.",
      },
    ],
    flowId: "BbGJpZwajZCaQrgoJ8Ro",
    shareUrl: "https://app.arcade.software/share/BbGJpZwajZCaQrgoJ8Ro",
    embedUrl:
      "https://demo.arcade.software/BbGJpZwajZCaQrgoJ8Ro?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/BbGJpZwajZCaQrgoJ8Ro/edit",
    guide: "docs/help/workspace-access.md#topic-64",
  },
  {
    id: 65,
    title: "Update organization details and timezone",
    group: "Workspace settings",
    category: "Workspace and organization",
    audience: "admin",
    tags: ["ORGANIZATION"],
    thumbnail: "https://app.arcade.software/og/l8FCg66JHA1TPtYIAIgC",
    placements: ["/settings/organization"],
    steps: 7,
    seconds: 11,
    chapters: [
      {
        title: "Update organization details",
        subtitle:
          "Change the organization name and website, save, and reopen the settings.",
      },
    ],
    flowId: "l8FCg66JHA1TPtYIAIgC",
    shareUrl: "https://app.arcade.software/share/l8FCg66JHA1TPtYIAIgC",
    embedUrl:
      "https://demo.arcade.software/l8FCg66JHA1TPtYIAIgC?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/l8FCg66JHA1TPtYIAIgC/edit",
    guide: "docs/help/organization-access.md#topic-65",
  },
  {
    id: 66,
    title: "Create and switch workspaces",
    group: "Workspace settings",
    category: "Workspace and organization",
    audience: "admin",
    tags: ["WORKSPACE"],
    nextId: 65,
    thumbnail: "https://app.arcade.software/og/BbGJpZwajZCaQrgoJ8Ro",
    placements: ["/settings/workspace"],
    steps: 17,
    seconds: 24,
    chapters: [
      {
        title: "Create a workspace",
        subtitle: "Create a workspace from the account menu.",
      },
      {
        title: "Rename the workspace",
        subtitle: "Update the workspace name in Workspace General.",
      },
      {
        title: "Switch workspaces",
        subtitle:
          "Switch to Dubai Clinic and back to verify the renamed workspace.",
      },
    ],
    flowId: "BbGJpZwajZCaQrgoJ8Ro",
    shareUrl: "https://app.arcade.software/share/BbGJpZwajZCaQrgoJ8Ro",
    embedUrl:
      "https://demo.arcade.software/BbGJpZwajZCaQrgoJ8Ro?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/BbGJpZwajZCaQrgoJ8Ro/edit",
    guide: "docs/help/workspace-access.md#topic-66",
  },
  {
    id: 68,
    title: "Create a contact",
    group: "Contacts",
    category: "Browse and profiles",
    audience: "agent",
    tags: ["CONTACT", "LIFECYCLE", "TAG"],
    nextId: 22,
    thumbnail: "https://app.arcade.software/og/ImBmQC4zxwPTYw0NbSzt",
    placements: ["/contacts"],
    steps: 18,
    seconds: 29,
    chapters: [
      {
        title: "Create a contact",
        subtitle: "Add Yasmin Nasser with contact details, lifecycle, and tag.",
      },
      {
        title: "Edit the contact",
        subtitle:
          "Find Yasmin, update her address and insurer, and verify the saved details.",
      },
    ],
    flowId: "ImBmQC4zxwPTYw0NbSzt",
    shareUrl: "https://app.arcade.software/share/ImBmQC4zxwPTYw0NbSzt",
    embedUrl:
      "https://demo.arcade.software/ImBmQC4zxwPTYw0NbSzt?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/ImBmQC4zxwPTYw0NbSzt/edit",
    guide: "docs/help/contacts.md#topic-68",
  },
  {
    id: 69,
    title: "Create, change and finish a follow-up",
    group: "Inbox and messaging",
    category: "Follow-ups, wrap-up and bulk",
    audience: "agent",
    tags: ["FOLLOW_UP"],
    nextId: 70,
    thumbnail: "https://app.arcade.software/og/6Ts2gPlfNnxrQvp8jaME",
    placements: ["/inbox"],
    steps: 23,
    seconds: 33,
    chapters: [
      {
        title: "Create a follow-up",
        subtitle: "Set a reminder for Emma Johnson for tomorrow.",
      },
      {
        title: "Edit the follow-up",
        subtitle: "Change the reminder reason and move it three days ahead.",
      },
      { title: "Finish the follow-up", subtitle: "Mark the reminder as done." },
      {
        title: "Remove a follow-up",
        subtitle: "Create another reminder and remove it.",
      },
      {
        title: "Review follow-up history",
        subtitle: "Open the contact profile to review past follow-ups.",
      },
    ],
    flowId: "6Ts2gPlfNnxrQvp8jaME",
    shareUrl: "https://app.arcade.software/share/6Ts2gPlfNnxrQvp8jaME",
    embedUrl:
      "https://demo.arcade.software/6Ts2gPlfNnxrQvp8jaME?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/6Ts2gPlfNnxrQvp8jaME/edit",
    guide: "docs/help/follow-ups.md#topic-69",
  },
  {
    id: 70,
    title: "Resolve or close, reopen and snooze a conversation",
    group: "Inbox and messaging",
    category: "Follow-ups, wrap-up and bulk",
    audience: "agent",
    tags: ["RESOLVE", "SNOOZE", "OUTCOME"],
    nextId: 71,
    thumbnail: "https://app.arcade.software/og/ijgTCZu4zmI5BivpOZ3d",
    placements: ["/inbox"],
    steps: 16,
    seconds: 23,
    chapters: [
      {
        title: "Resolve the conversation",
        subtitle:
          "Use Quick Close with a category and summary to resolve the conversation.",
      },
      {
        title: "Reopen the conversation",
        subtitle: "Open the resolved conversation again.",
      },
      {
        title: "Snooze the conversation",
        subtitle: "Snooze the conversation until tomorrow.",
      },
      {
        title: "Unsnooze the conversation",
        subtitle: "Bring the snoozed conversation back to the inbox.",
      },
    ],
    flowId: "ijgTCZu4zmI5BivpOZ3d",
    shareUrl: "https://app.arcade.software/share/ijgTCZu4zmI5BivpOZ3d",
    embedUrl:
      "https://demo.arcade.software/ijgTCZu4zmI5BivpOZ3d?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/ijgTCZu4zmI5BivpOZ3d/edit",
    guide: "docs/help/resolve-conversations.md#topic-70",
  },
  {
    id: 71,
    title: "Select conversations and apply bulk actions",
    group: "Inbox and messaging",
    category: "Follow-ups, wrap-up and bulk",
    audience: "agent",
    tags: ["BULK", "TAG", "WORKFLOW"],
    nextId: 72,
    thumbnail: "https://app.arcade.software/og/iICs0wbxVaKJQfJJl8SD",
    placements: ["/inbox"],
    steps: 56,
    seconds: 64,
    chapters: [
      {
        title: "Select conversations",
        subtitle:
          "Select individual conversations, select all matches, and clear the selection.",
      },
      {
        title: "Update tags",
        subtitle:
          "Add the Referred tag to two conversations and verify both contacts.",
      },
      {
        title: "Add a private note",
        subtitle: "Add the same private note to two selected conversations.",
      },
      {
        title: "Transfer conversations",
        subtitle:
          "Transfer selected conversations to Front Desk with a reason.",
      },
      {
        title: "Resolve conversations",
        subtitle:
          "Apply Quick Close with a category and summary to two conversations.",
      },
      {
        title: "Run a workflow",
        subtitle: "Start Consultation follow-up for the selected contacts.",
      },
      {
        title: "Check duplicate workflow runs",
        subtitle:
          "Run the same workflow again to see that active contacts are skipped.",
      },
    ],
    flowId: "iICs0wbxVaKJQfJJl8SD",
    shareUrl: "https://app.arcade.software/share/iICs0wbxVaKJQfJJl8SD",
    embedUrl:
      "https://demo.arcade.software/iICs0wbxVaKJQfJJl8SD?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/iICs0wbxVaKJQfJJl8SD/edit",
    guide: "docs/help/resolve-conversations.md#topic-71",
  },
  {
    id: 72,
    title: "Mention a teammate in a private note",
    group: "Inbox and messaging",
    category: "Follow-ups, wrap-up and bulk",
    audience: "agent",
    tags: ["NOTE", "MENTION"],
    thumbnail: "https://app.arcade.software/og/ToB0d3MK1EHDFLT4Kl9f",
    placements: ["/inbox"],
    steps: 7,
    seconds: 13,
    chapters: [
      {
        title: "Mention a teammate",
        subtitle: "Mention Mariam in a private note with a booking request.",
      },
    ],
    flowId: "ToB0d3MK1EHDFLT4Kl9f",
    shareUrl: "https://app.arcade.software/share/ToB0d3MK1EHDFLT4Kl9f",
    embedUrl:
      "https://demo.arcade.software/ToB0d3MK1EHDFLT4Kl9f?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/ToB0d3MK1EHDFLT4Kl9f/edit",
    guide: "docs/help/internal-notes.md#topic-72",
  },
  {
    id: 73,
    title:
      "Record appointment outcomes and find appointments needing attention",
    group: "Appointments and clinic",
    category: "Appointments",
    audience: "agent",
    tags: ["APPOINTMENT", "OUTCOME"],
    thumbnail: "https://app.arcade.software/og/GU2dE2krUXhr4nsE9ibL",
    placements: ["/appointments"],
    steps: 10,
    seconds: 16,
    chapters: [
      {
        title: "Find appointments needing attention",
        subtitle: "Open the consultation for Hana in the Need attention list.",
      },
      {
        title: "Record the appointment outcome",
        subtitle: "Record attendance, a free visit, and the booked treatment.",
      },
    ],
    flowId: "GU2dE2krUXhr4nsE9ibL",
    shareUrl: "https://app.arcade.software/share/GU2dE2krUXhr4nsE9ibL",
    embedUrl:
      "https://demo.arcade.software/GU2dE2krUXhr4nsE9ibL?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/GU2dE2krUXhr4nsE9ibL/edit",
    guide: "docs/help/appointments.md#topic-73",
  },
  {
    id: 84,
    title: "Review Echo suggestions and knowledge gaps",
    group: "Echo AI",
    category: "Suggestions",
    audience: "admin",
    tags: ["ECHO", "SUGGESTION"],
    thumbnail: "https://app.arcade.software/og/Tb42vuYHXynAaCX7XFaI",
    placements: ["/echo/suggestions"],
    steps: 13,
    seconds: 21,
    chapters: [
      {
        title: "Publish an Echo suggestion",
        subtitle:
          "Add the ready membership suggestion to business information.",
      },
      {
        title: "Dismiss a suggestion",
        subtitle: "Review the laser question and mark it as not worth keeping.",
      },
      {
        title: "Verify reviewed suggestions",
        subtitle:
          "Search Everything to check the published and dismissed cards.",
      },
    ],
    flowId: "Tb42vuYHXynAaCX7XFaI",
    shareUrl: "https://app.arcade.software/share/Tb42vuYHXynAaCX7XFaI",
    embedUrl:
      "https://demo.arcade.software/Tb42vuYHXynAaCX7XFaI?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/Tb42vuYHXynAaCX7XFaI/edit",
    guide: "docs/help/echo-review.md#topic-84",
  },
  {
    id: 101,
    title: "Search conversations in the inbox",
    group: "Inbox and messaging",
    category: "Conversation actions",
    audience: "agent",
    tags: ["SEARCH", "CONTACT", "MESSAGE"],
    nextId: 102,
    thumbnail: "https://app.arcade.software/og/ttAfGJPqpUJiW8catBFn",
    placements: ["/inbox/:id"],
    steps: 9,
    seconds: 15,
    chapters: [
      {
        title: "Search by contact",
        subtitle: "Find Emma Johnson using the Contact search tab.",
      },
      {
        title: "Search message text",
        subtitle:
          "Search for consultation messages, then clear and close the search.",
      },
    ],
    flowId: "ttAfGJPqpUJiW8catBFn",
    shareUrl: "https://app.arcade.software/share/ttAfGJPqpUJiW8catBFn",
    embedUrl:
      "https://demo.arcade.software/ttAfGJPqpUJiW8catBFn?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/ttAfGJPqpUJiW8catBFn/edit",
    guide: "docs/help/inbox-filters.md#topic-101",
  },
  {
    id: 102,
    title: "Block and unblock a contact from the inbox",
    group: "Inbox and messaging",
    category: "Conversation actions",
    audience: "agent",
    tags: ["BLOCK", "CONTACT"],
    nextId: 103,
    thumbnail: "https://app.arcade.software/og/IJKEzBBt4fhh6dtfMBjP",
    placements: ["/inbox/:id"],
    steps: 7,
    seconds: 14,
    chapters: [
      {
        title: "Block the contact",
        subtitle: "Block Emma from the conversation's More options menu.",
      },
      {
        title: "Unblock the contact",
        subtitle: "Reopen More options, unblock Emma, and verify the menu.",
      },
    ],
    flowId: "IJKEzBBt4fhh6dtfMBjP",
    shareUrl: "https://app.arcade.software/share/IJKEzBBt4fhh6dtfMBjP",
    embedUrl:
      "https://demo.arcade.software/IJKEzBBt4fhh6dtfMBjP?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/IJKEzBBt4fhh6dtfMBjP/edit",
    guide: "docs/help/conversation-actions.md#topic-102",
  },
  {
    id: 103,
    title: "Run a workflow from a conversation",
    group: "Inbox and messaging",
    category: "Conversation actions",
    audience: "agent",
    tags: ["WORKFLOW"],
    nextId: 45,
    thumbnail: "https://app.arcade.software/og/Ex9OBF3JSXX0v80u6pQe",
    placements: ["/inbox/:id"],
    steps: 12,
    seconds: 21,
    chapters: [
      {
        title: "Run a workflow",
        subtitle: "Start Consultation follow-up from the conversation.",
      },
      {
        title: "Pause the workflow",
        subtitle: "Open Workflows and confirm pausing the active run.",
      },
      { title: "Resume the workflow", subtitle: "Resume the paused workflow." },
      {
        title: "Cancel the workflow",
        subtitle: "Enter a cancellation reason and confirm cancelling the run.",
      },
    ],
    flowId: "Ex9OBF3JSXX0v80u6pQe",
    shareUrl: "https://app.arcade.software/share/Ex9OBF3JSXX0v80u6pQe",
    embedUrl:
      "https://demo.arcade.software/Ex9OBF3JSXX0v80u6pQe?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true",
    editUrl: "https://app.arcade.software/flows/Ex9OBF3JSXX0v80u6pQe/edit",
    guide: "docs/help/conversation-actions.md#topic-103",
  },
];
